import React from 'react';
import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import VisibilityIcon from '@mui/icons-material/Visibility';

const NegativeContrast = ({ isFilterActive, toggleOption }) => {
	const handleNegativeContrast = () => {
		if (!isFilterActive) {
			document.querySelectorAll('.filter').forEach((element) => {
				element.style.filter = 'invert(100%)';
			});
			document.querySelectorAll('.filterbg').forEach((element) => {
				element.style.backgroundColor = 'black';
			});

			document.querySelectorAll('.footerfilter').forEach((element) => {
				element.style.filter = '';
				element.style.background = '';
			});
		}

		toggleOption();
	};
	return (
		<ListItem
			className='accessiblility-links'
			tabIndex={1}
			sx={{
				padding: '2px 18px',
				cursor: 'pointer',
				fontSize: '14px',
				background: isFilterActive
					? (theme) => theme.palette.accessibilityBtn.main
					: (theme) => theme.palette.common.white,
				color: isFilterActive ? (theme) => theme.palette.common.white : 'inherit'
			}}
			onClick={handleNegativeContrast}
			onKeyDown={(event) => {
				if (event.key === 'Enter') {
					handleNegativeContrast();
				}
			}}
		>
			<VisibilityIcon sx={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '5px' }} />

			<ListItemText
				primary='Negative Contrast'
				primaryTypographyProps={{ sx: { fontSize: '14px' } }}
			/>
		</ListItem>
	);
};

NegativeContrast.propTypes = {
	isFilterActive: PropTypes.bool,
	toggleOption: PropTypes.func
};

export default NegativeContrast;
